import { InjectionKey, ComputedRef } from 'vue';
import _mergeWith from 'lodash/mergeWith';
import merge from 'lodash/merge';
import defaultConfig from '../_common/js/global-config/default-config';
import defaultZhLocale from '../_common/js/global-config/locale/zh_CN';
import { GlobalConfigProvider } from 'tdesign-vue-next';
import isArray from 'lodash/isArray';

export enum EAnimationType {
  ripple = 'ripple',
  expand = 'expand',
  fade = 'fade',
}

export type ChatGlobalConfigProvider = GlobalConfigProvider & {
  chat: {
    placeholder: string;
    stopBtnText: string;
    refreshTipText: string;
    copyTipText: string;
    likeTipText: string;
    dislikeTipText: string;
    copyCodeBtnText: string;
    copyCodeSuccessText: string;
    clearHistoryBtnText: string;
    copyTextSuccess: string;
    copyTextFail: string;
    confirmClearHistory: string;
  };
};

export const defaultGlobalConfig = merge(defaultConfig, defaultZhLocale);

export type Locale = typeof defaultZhLocale;

export const configProviderInjectKey: InjectionKey<ComputedRef<ChatGlobalConfigProvider>> = Symbol('configProvide');

export const mergeWith = (defaultGlobalConfig: ChatGlobalConfigProvider, injectConfig: ChatGlobalConfigProvider) =>
  _mergeWith(defaultGlobalConfig, injectConfig, (objValue, srcValue) => {
    if (isArray(objValue)) {
      return srcValue;
    }
  });
